import { AbsenceOccurrence } from '../../types/absence'
import PrintHeader from './SCANetherlandsPrint/PrintHeader'
import EmployeeSection from './SCANetherlandsPrint/EmployeeSection'
import AbsenceDetailsSection from './SCANetherlandsPrint/AbsenceDetailsSection'
import WorkingDaysSection from './SCANetherlandsPrint/WorkingDaysSection'
import CertificationSection from './SCANetherlandsPrint/CertificationSection'
import DigitalSignature from './SCANetherlandsPrint/DigitalSignature'

interface scaResponse {
  nonWorkingDays?: number
  normalWeekWorkingDays?: number
  absenceReasonText?: string
  medicalPractitionerConsultedType: string
  medicalPractitionerComments?: string
  displayName: string
  date: string
  ip: string
}

type Props = {
  absenceOccurrence: AbsenceOccurrence
  sca: scaResponse
}

function SCANetherlandsPrint({ absenceOccurrence, sca }: Props) {
  const totalHoursLost = () => {
    let result = 0
    absenceOccurrence.absenceDays.forEach(day => {
      result += day.hoursLost
    })
    return result
  }
    
  return (
    <div>
      <PrintHeader title="Self-Certification of Absence" />
      <EmployeeSection employee={absenceOccurrence.employeeResponse} />
      <AbsenceDetailsSection absence={absenceOccurrence} totalHoursLost={totalHoursLost()} />
      <WorkingDaysSection sca={sca} />
      <CertificationSection />
      <DigitalSignature sca={sca} />
    </div>
  )
}

export default SCANetherlandsPrint
